export enum Role {
	owner = "owner",
	admin = "admin"
}
